<template>
  <div class="demand-content">
    <a-row>
      <a-col :span="6">
        <p>售价</p>
        <p v-if="userInfo.requirementPriceStart" class="bold">
          <!-- {{ userInfo.requirementPriceStart | keepTwo_wan }} - {{ userInfo.requirementPriceEnd | keepTwo_wan }} -->
          {{ userInfo.requirementPriceStart ? userInfo.requirementPriceStart :'-' }}万 ~ {{ userInfo.requirementPriceEnd ? userInfo.requirementPriceEnd :'-' }}万元
        </p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col :span="6">
        <p>区域</p>
        <p v-if="userInfo.districtName" class="bold">{{ userInfo.districtName }}</p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col
        :span="6"
      ><p>商圈</p>
        <p class="bold" v-if="userInfo.businessDistrictName">{{ userInfo.businessDistrictName }}</p>
        <p v-else class="bold">-</p></a-col
      >
      <a-col
        :span="6"
      ><p>街道</p>
        <p class="bold" v-if="userInfo.streetName">{{ userInfo.streetName }}</p>
        <p v-else class="bold">-</p>
      </a-col>
    </a-row>
    <a-row style="margin-top: 10px">
      <a-col :span="6">
        <p>等级</p>
        <p v-if="userInfo.requirementLevel" class="bold">
          {{ userInfo.requirementLevel | filterDict(requirement_level_list) }}
        </p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col :span="6">
        <p>付款方式</p>
        <p v-if="userInfo.paymentType" class="bold">
          {{ userInfo.paymentType | filterDict(payment_method_list) }}
        </p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col
        :span="6"
      ><p>客户类型</p>
        <p v-if="userInfo.customerType" class="bold">{{ userInfo.customerType | filterDict(customer_type_list) }}</p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col
        :span="6"
      ><p>投资类型</p>
        <p class="bold" v-if="userInfo.investmentType">
          {{ userInfo.investmentType | filterDict(investment_type_list) }}
        </p>
        <p v-else class="bold">-</p>
      </a-col>
    </a-row>
    <a-row style="margin-top: 10px">
      <a-col :span="6">
        <p>是否投资其他房源</p>
        <p class="bold" v-if="userInfo.isInvestmentOtherHouse">
          {{ userInfo.isInvestmentOtherHouse | filterDict(sys_yes_no_list) }}
        </p>
        <p v-else class="bold">-</p>
      </a-col>
      <a-col :span="6">
        <p>商铺性质</p>
        <p v-if="userInfo.shopNatureId" class="bold">{{ userInfo.shopNatureId | filterDict(shop_nature_list) }}</p>
        <p v-else class="bold">-</p>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      shop_nature_list: [],
      payment_method_list: [],
      customer_type_list: [],
      investment_type_list: [],
      requirement_level_list: [],
      sys_yes_no_list: []
    }
  },
  methods: {
    DICT () {
      this.getDicts('shop_nature').then((response) => {
        this.shop_nature_list = response.data
        // console.log('商铺性质', this.typeOptions)
      })
      this.getDicts('payment_type2').then((response) => {
        this.payment_method_list = response.data
        // console.log('付款方式', this.payment_method_list)
      })
      this.getDicts('customer_type').then((response) => {
        this.customer_type_list = response.data
        // console.log('客户类型', this.customer_type_list)
      })
      this.getDicts('investment_type').then((response) => {
        this.investment_type_list = response.data
        // console.log('投资类型', this.investment_type_list)
      })
      this.getDicts('requirement_level').then((response) => {
        this.requirement_level_list = response.data
        // console.log('需求等级', this.requirement_level_list)
      })
      this.getDicts('sys_yes_no').then((response) => {
        this.sys_yes_no_list = response.data
        // console.log('是否', this.requirement_level_list)
      })
    }
  },

  created () {
    this.DICT()

    // console.log(this.userInfo)
  }
}
</script>

<style lang="less" scoped>
.demand-content {
  padding: 10px;
  p {
    margin-bottom: 8px;
  }
  .bold {
    font-weight: bold;
    color: #000;
    font-size: 14px;
  }
}
</style>
